import {
  NPVR_ADD_EVENT_INIT,
  NPVR_ADD_EVENT_SUCCESS,
  NPVR_ADD_EVENT_ERROR,
  NPVR_ADD_EVENT_CLEAR,
} from '../../actions/recording/constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NPVR_ADD_EVENT_INIT:
      return { ...state, loading: true, error: null, data: null };
    case NPVR_ADD_EVENT_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case NPVR_ADD_EVENT_ERROR:
      return { ...state, loading: false, error: action.error, data: null };
    case NPVR_ADD_EVENT_CLEAR:
      return { ...state, loading: false, data: null, error: false };
    default:
      return state;
  }
};
